import React, { memo } from 'react';
import classNames from 'classnames';
import { Cross } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../utils';
import DialerInCallKeypad from './dialer-in-call-keypad';

export interface DialerInCallKeypadSheetProps {
  isOpen: boolean;
  onClose: () => void;
  inline?: boolean;
  value: string;
  onChange: (value: string) => void;
  onSendDtmf: (digit: string) => void;
}

const DialerInCallKeypadSheet: React.FC<DialerInCallKeypadSheetProps> = ({
  isOpen,
  onClose,
  inline = false,
  value,
  onChange,
  onSendDtmf,
}) => (
  <div className={`${inline ? 'dialer-in-call-keypad-sheet-layer' : ''}`}>
    <div
      className={classNames('phone-numbers-bottom-sheet-backdrop', {
        'phone-numbers-bottom-sheet-backdrop--open': isOpen,
        'phone-numbers-bottom-sheet-backdrop--inline': inline,
      })}
      aria-hidden={!isOpen}
      {...accessibleOnClick(onClose)}
    />
    <div
      className={classNames('phone-numbers-bottom-sheet', {
        'phone-numbers-bottom-sheet--open': isOpen,
        'phone-numbers-bottom-sheet--inline': inline,
      })}
      aria-modal="true"
      role="dialog"
      aria-label="Keypad"
    >
      <div className="phone-numbers-bottom-sheet-handle">
        <div className="phone-numbers-bottom-sheet-handle-bar">
          <span className="phone-number-selected-prospect-name">Keypad</span>
          <div
            className="phone-numbers-bottom-sheet-close-icon"
            {...accessibleOnClick(onClose)}
          >
            <Cross width={16} height={16} />
          </div>
        </div>
      </div>
      <div className="phone-numbers-bottom-sheet-content phone-numbers-bottom-sheet-content--in-call-keypad">
        <DialerInCallKeypad
          isActive={isOpen}
          value={value}
          onChange={onChange}
          onSendDtmf={onSendDtmf}
        />
      </div>
    </div>
  </div>
);

export default memo(DialerInCallKeypadSheet);
